<template>
  <el-main>
    <div class="formSubmitBtnBox">
      <el-button style="margin: 10px;" @click="cancal()">取消</el-button>
      <el-button
        v-if="this.$route.params.id > 0"
        type="primary"
        style="margin: 10px;"
        @click="lecturerInfoUpdate()"
        >儲存</el-button
      >
      <el-button
        v-else
        type="primary"
        style="margin: 10px;"
        @click="lecturerInfoAdd()"
        >新增</el-button
      >
    </div>

    <el-row>
      <el-form :model="lecturerInfo" class="demo-ruleForm" status-icon>
        <el-col :span="20" :offset="2">
          <el-row class="block-div">
            <el-col :span="10">
              <div v-if="this.$route.params.id > 0" align="center">
                <img
                  :src="lecturerInfo.photoUrl"
                  alt="原照片"
                  class="lecturer-img"
                />
              </div>
              <el-form-item label="更換照片" prop="picture" class="upload-div">
                <PictureUploader
                  :fileQuantityLimit="1"
                  :fileList.sync="fileList"
                ></PictureUploader>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="姓名" prop="name" style="margin:0 28px 20px">
                <el-input
                  style="width:300px"
                  type="text"
                  v-model.trim="lecturerInfo.name"
                  autocomplete="off"
                  maxlength="150"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="講師效期" prop="startDate">
                <el-date-picker
                  style="width:300px"
                  v-model="lecturerInfo.startDate"
                  type="date"
                  value-format="yyyy/MM/dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="地區" prop="name" style="margin:0 28px 10px">
                <el-select
                  v-model="lecturerInfo.lecturerAreaList"
                  multiple
                  placeholder="請選擇地區"
                  style="width:300px"
                >
                  <el-option
                    v-for="item in lecturerAreaListSelecter"
                    :key="item"
                    :label="
                      item === 1
                        ? '北部'
                        : item === 2
                        ? '中部'
                        : item === 3
                        ? '南部'
                        : item === 4
                        ? '東部'
                        : ''
                    "
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="前台顯示" prop="show" style="margin:15px 0">
                <el-radio-group v-model="lecturerInfo.show">
                  <el-radio :label="true">顯示</el-radio>
                  <el-radio :label="false">不顯示</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="邀請次數" prop="invitedTimes">
                <div>
                  {{ lecturerInfo.invitedTimes }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="block-div">
            <el-col :span="24">
              <el-form-item label="" prop="summary">
                <div style="font-size:20px;">簡易介紹</div>
                <el-input
                  type="textarea"
                  v-model.trim="lecturerInfo.summary"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                  autocomplete="off"
                  maxlength="150"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="block-div">
            <el-col :span="24">
              <el-form-item label="" prop="summary">
                <div style="font-size:20px;">
                  詳細介紹 (註 : 某些功能前台無法套用，請以前台畫面為主)
                </div>
                <!-- bidirectional data binding（双向数据绑定） -->
                <quill-editor
                  style="background-color:white"
                  v-model="lecturerInfo.introduction"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                >
                </quill-editor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-form>
    </el-row>
  </el-main>
</template>

<script>
import {
  C_Lecturer_Get,
  C_Lecturer_Update,
  C_Lecturer_Add,
} from '@/assets/js/api';
import PictureUploader from '@/components/PictureUploader.vue';

export default {
  data() {
    return {
      originalPhotoUrl: '',
      editorOption: {
        modules: {
          imageResize: {
            // 添加
            displayStyles: {
              // 添加
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'], // 添加
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'image'],
            ['formula', 'clean'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ direction: 'rtl' }],
          ],
        },
        placeholder: '請輸入内容........',
      },
      search: '',
      fileList: [],
      lecturerAreaListSelecter: [1, 2, 3, 4],
      lecturerInfo: {
        id: '',
        name: '',
        summary: '',
        introduction: '',
        invitedTimes: 0,
        lecturerAreaList: [],
        show: null,
        sort: null,
        startDate: '',
        endDate: '',
        status: '',
        photoUrl: '',
      },
    };
  },
  components: {
    PictureUploader,
  },
  watch: {
    fileList() {
      if (this.fileList.length > 0) this.lecturerInfo.photoUrl = this.fileList[0].url;
      if (this.fileList.length < 1) this.lecturerInfo.photoUrl = this.originalPhotoUrl;
    },
  },
  methods: {
    onEditorBlur() {
      // console.log('editor blur!', quill);
    },
    onEditorFocus() {
      // console.log('editor focus!', quill);
    },
    onEditorReady() {
      // console.log('editor ready!', quill);
    },
    // onEditorChange({ quill, html, text }) {
    //   console.log('editor change!', quill, html, text);
    //   this.content = html;
    // },
    getLecturerInfo() {
      if (this.$route.params.id > 0) {
        C_Lecturer_Get(this.$route.params.id)
          .then((res) => {
            console.log(res.data.data);
            this.lecturerInfo = res.data.data;
            this.lecturerInfo.startDate = this.lecturerInfo.startDate
              .substring(0, 10)
              .replace(/-/g, '/');
            this.originalPhotoUrl = this.lecturerInfo.photoUrl;
          })
          .catch((err) => console.log(err));
      }
    },
    lecturerInfoUpdate() {
      const lecturerFormData = new FormData();
      lecturerFormData.append('name', this.lecturerInfo.name);
      lecturerFormData.append('summary', this.lecturerInfo.summary);
      lecturerFormData.append('introduction', this.lecturerInfo.introduction);

      this.lecturerInfo.lecturerAreaList.forEach((i, index) => {
        lecturerFormData.append(
          'lecturerAreaList[]',
          this.lecturerInfo.lecturerAreaList[index],
        );
      });
      lecturerFormData.append(
        'sort',
        this.lecturerInfo.sort === null ? 0 : this.lecturerInfo.sort,
      );
      lecturerFormData.append('show', this.lecturerInfo.show);
      lecturerFormData.append('startDate', this.lecturerInfo.startDate);
      lecturerFormData.append(
        'photo',
        this.fileList.length === 0 ? null : this.fileList[0].raw,
      );

      console.log(this.fileList.length === 0 ? null : this.fileList[0].raw);

      C_Lecturer_Update(this.$route.params.id, lecturerFormData)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
          });
          this.getLecturerInfo();
        })
        .catch((err) => {
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        });
    },

    lecturerInfoAdd() {
      let flag = false;
      if (this.lecturerInfo.name === '' || this.lecturerInfo.name === null) {
        flag = true;
      }

      if (
        this.lecturerInfo.startDate === ''
        || this.lecturerInfo.startDate === null
      ) {
        flag = true;
      }

      if (this.lecturerInfo.lecturerAreaList.length < 1) {
        flag = true;
      }

      if (this.fileList.length < 1) {
        flag = true;
      }

      if (flag) {
        this.$notify({
          title: '注意',
          message: '有欄位尚未填寫',
          type: 'warning',
        });
        return false;
      }

      const AddFormData = new FormData();
      AddFormData.append('name', this.lecturerInfo.name);
      AddFormData.append('summary', this.lecturerInfo.summary);
      AddFormData.append('introduction', this.lecturerInfo.introduction);

      this.lecturerInfo.lecturerAreaList.forEach((i, index) => {
        AddFormData.append(
          'lecturerAreaList[]',
          this.lecturerInfo.lecturerAreaList[index],
        );
      });
      AddFormData.append('show', this.lecturerInfo.show);
      AddFormData.append('startDate', this.lecturerInfo.startDate);
      AddFormData.append(
        'photo',
        this.fileList.length === 0 ? null : this.fileList[0].raw,
      );

      C_Lecturer_Add(AddFormData)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
          });
          this.$router.go(-1);
          this.fileList = [];
        })
        .catch((err) => {
          this.$notify({
            title: '失敗',
            message:
              err.response.data.message === null
                ? '請確認欄位是否皆填寫'
                : err.response.data.message,
            type: 'error',
          });
        });

      return true;
    },
    cancal() {
      this.$router.go(-1);
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    this.$refs.myQuillEditor.quill.focus(false);
    // if (this.$route.params.id > 0) {
    //   C_Lecturer_Get(this.$route.params.id)
    //     .then((res) => {
    //       this.lecturerInfo = res.data.data;
    //     })
    //     .catch((err) => console.log(err));
    // }
    this.getLecturerInfo();

    // console.log('this is current quill instance object', this.editor);
  },
};
</script>

<style scoped>
.block-div {
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #0089fa10;
  margin: 20px 0;
}
.upload-div {
  margin: 0 40px 0 0;
}
.lecturer-img {
  width: 250px;
  height: 250px;
  object-fit: contain;
}
</style>
